/*
@author: Nikhil 


jvActions
============
@desc: Used to show a list of actions
@include : _actions.scss
Usage: 
    javascript: 
        Declare a list of action links with visibility logic and click events. 
        //Actions onfig
        var actions = [
            {
                type: 'a',
                showCondition: 'perms.APPLICATION_ADD_TO_REQUISITION_POST',
                classNames: ['marginRight10','width-inherit','block'],
                clickEvent: 'triggerModal(\'showAddToReqModal\',{appIds:[applicationId],name:appDetails.application.candidate})',
                text: $scope.i18n['ADD_TO_REQUISITION']
            },
            {
                type: 'a',
                showCondition: 'perms.APPLICATION_MOVE_CANDIDATE',
                classNames: ['marginRight10', 'width-inherit','block'],
                clickEvent: 'triggerModal(\'showMoveCandidateModal\',{appIds:[applicationId],name:appDetails.application.candidate})',
                text: $scope.i18n['MOVE']+' '+$scope.i18n['CANDIDATE']
            },
            {
                type: 'a',
                showCondition: 'perms.APPLICATION_SEND_JOBVITE_POST && appDetails.application.job.sendJobvite',
                classNames: ['marginRight10', 'width-inherit','block'],
                clickEvent: 'redirectToSendJobvite()',
                text: $scope.i18n['SEND_JOBVITE']
            },
            {
                type: 'a',
                showCondition: 'perms.APPLICATION_DELETE',
                classNames: ['marginRight10', 'width-inherit','block'],
                clickEvent: 'triggerModal(\'showDeleteCandidateModal\',{appIds:[applicationId],name:appDetails.application.candidate})',
                text: $scope.i18n['DELETE']+' '+$scope.i18n['CANDIDATE']
            }
        ];
    html: 
    <div ng-if="primaryActions" jv-actions="primaryActions" class="left">


jvActionsDropdown : Note Will be removed after candidate centric
============
@desc: Used to show a actionsDropdown
@include : _actionsDropdown.scss
Usage: 
    javascript: 
        Declare a list of action links with visibility logic and click events. 
        var actions = [
            {
                type: 'a',
                showCondition: 'perms.APPLICATION_ADD_TO_REQUISITION_POST',
                classNames: ['marginRight10','width-inherit','block'],
                clickEvent: 'triggerModal(\'showAddToReqModal\',{appIds:[applicationId],name:appDetails.application.candidate})',
                text: $scope.i18n['ADD_TO_REQUISITION']
            },
            {
                type: 'a',
                showCondition: 'perms.APPLICATION_MOVE_CANDIDATE',
                classNames: ['marginRight10', 'width-inherit','block'],
                clickEvent: 'triggerModal(\'showMoveCandidateModal\',{appIds:[applicationId],name:appDetails.application.candidate})',
                text: $scope.i18n['MOVE']+' '+$scope.i18n['CANDIDATE']
            },
            {
                type: 'a',
                showCondition: 'perms.APPLICATION_SEND_JOBVITE_POST && appDetails.application.job.sendJobvite',
                classNames: ['marginRight10', 'width-inherit','block'],
                clickEvent: 'redirectToSendJobvite()',
                text: $scope.i18n['SEND_JOBVITE']
            },
            {
                type: 'a',
                showCondition: 'perms.APPLICATION_DELETE',
                classNames: ['marginRight10', 'width-inherit','block'],
                clickEvent: 'triggerModal(\'showDeleteCandidateModal\',{appIds:[applicationId],name:appDetails.application.candidate})',
                text: $scope.i18n['DELETE']+' '+$scope.i18n['CANDIDATE']
            }
        ];
    html: 
        <a jv-actions-dropdown="actionsDropDownConfig" class=" actionsDropdown"><i class="icon-expand icon action-expand"></i><span class="left">Actions<span></a>
 */

angular.module('jv.Common.Directives.Actions', [])

.directive('jvActions', function($compile){
    return {
        scope: {
            actions : '='
        },
        link: function(scope, iElm, iAttrs) {

            var createHtml = function(htmlObj){
                var htmlElem = '', htmlElemStart = '',htmlElemContent = '', htmlElemEnd = '';
                
                //add show conditions
                if(htmlObj.showCondition){
                    htmlElemContent += 'ng-show="'+htmlObj.showCondition+'"';
                }
                //add hide conditions
                if(htmlObj.hideCondition){
                    htmlElemContent += 'ng-hide="'+htmlObj.hideCondition+'"';
                }
                
                //construct html based on the type of element
                switch(htmlObj.type){
                    case 'a':
                        htmlElemStart = '<a ';
                        htmlElemContent += 'ng-click="'+htmlObj.clickEvent+'" class="'+htmlObj.classNames.join(' ')+'">'+htmlObj.text;
                        htmlElemEnd = '</a>';
                    break;
                    case 'check':
                        htmlElemStart = '<span class="marginLeft5 marginRight5"><input type="checkbox"';
                        htmlElemContent += 'ng-model="'+htmlObj.ngModel + '" ng-click="'+htmlObj.clickEvent + '" value="'+htmlObj.value+ '" class="'+htmlObj.checkboxClass.join(' ')+'">';
                        htmlElemEnd = '<label class="'+htmlObj.labelClass.join(' ')+'">'+htmlObj.text+'</label></input></span>';
                    break;
                }
                htmlElem = htmlElemStart + htmlElemContent + htmlElemEnd;
                return htmlElem;
            };

            var renderActions = function(actions){
                var actionLinks = actions;
                if(actionLinks.length){
                    $(iElm).html('');
                    angular.forEach(actionLinks,function(actionItem,key){
                        var actionHtml = createHtml(actionItem);
                        var content = $compile(actionHtml)(scope.$parent);
                        $(iElm).append(content);
                    });
                } else {
                    $(iElm).html('');
                    var content = '';
                    $(iElm).append(content);
                }
            };
            scope.$watch('actions',function(newVal, oldVal){
                if(newVal){
                    renderActions(scope.actions);
                }
            });
        }
        
    };
})

.directive('jvActionsDropdown', function($compile){
    return {
        link: function(scope, iElm, iAttrs) {
            var actionLinks = scope.$eval(iAttrs.jvActionsDropdown);
            var linkHtml,content,container;
            container = '<div class="actionsDropdownContainer"></div>';
            $(iElm).append(container);
            angular.forEach(actionLinks,function(link,key){
                link.classNames.push('action-link');
                linkHtml = '<a ng-show="'+link.showCondition+'"ng-click="'+link.clickEvent+'"><i class="'+link.classNames.join(' ')+'"></i>'+link.text+'</a>';
                content = $compile(linkHtml)(scope);
                $('.actionsDropdownContainer').append(content);
            });
        }
        
    };
});
